
import React from "react";
import "../css/Valores.css";

import Valor1 from "../img/Valores/respeto.png";
import Valor2 from "../img/Valores/tolerancia.png";
import Valor3 from "../img/Valores/compromiso.png";

const Valores = () => {

    return (

        <section
            id="valores-component"
            className="esc-valores-section"
        >

            <div className="esc-valores-container">

                <h2 className="esc-valores-title">

                    Valores

                </h2>

                <p className="esc-valores-subtitle">

                    Nuestros Valores son...

                </p>

                <div className="esc-valores-grid">

                    {/* ================= RESPETO ================= */}

                    <article className="esc-valores-card esc-valores-red">

                        <h3 className="esc-valores-card-title">

                            Respeto

                        </h3>

                        <img
                            src={Valor1}
                            alt="Ícono Respeto"
                            className="esc-valores-icon"
                        />

                        <p className="esc-valores-description">

                            Hace referencia a una actitud moral por la que se aprecia la dignidad de una persona y se considera su libertad para comportarse tal cual es, de acuerdo con su voluntad, intereses, opiniones, sin tratar de imponer una determinada forma de ser y de pensar. En el proceso formativo y de desarrollo de nuestras y nuestros estudiantes, este valor se va construyendo a través de la interacción social, cuidado medio ambiental y sostenibilidad, y es imprescindible interiorizarlo en cada individuo, de manera gradual. Valoramos la libertad de ser y de pensar de cada individuo, sin pasar a llevar los derechos de los demás, tomando relevancia el considerar los diferentes contextos en los que nos relacionamos, como sujetos, insertos en una comunidad y en la sociedad.
                        </p>

                    </article>

                    {/* ================= TOLERANCIA ================= */}

                    <article className="esc-valores-card esc-valores-blue">

                        <h3 className="esc-valores-card-title">

                            Tolerancia

                        </h3>

                        <img
                            src={Valor2}
                            alt="Ícono Tolerancia"
                            className="esc-valores-icon"
                        />

                        <p className="esc-valores-description">

                            Esta, es una virtud moral y política universal que implica el respeto mutuo e íntegro hacia las otras personas, la aceptación de la diversidad de opinión, social, étnica, cultural y religiosa en un contexto de valoración de los derechos humanos de todos y todas. Nos ayuda a valorar las distintas formas de entender y posicionarse en la vida, siempre que no atenten contra los derechos fundamentales de las personas. Una posición activa de la Tolerancia incorpora una práctica que admite: oposición, reclamo o denuncia ante ciertas actitudes, impugnando la intolerancia y considerando formativamente que este valor se pone a prueba diariamente frente a las divergencias en las que nos vemos inmersos.

                        </p>

                    </article>

                    {/* ================= COMPROMISO ================= */}

                    <article className="esc-valores-card esc-valores-red">

                        <h3 className="esc-valores-card-title">

                            Compromiso

                        </h3>

                        <img
                            src={Valor3}
                            alt="Ícono Compromiso"
                            className="esc-valores-icon"
                        />

                        <p className="esc-valores-description">

                            Entenderemos este valor como un fenómeno biopsicosocial, que incorpora pensamientos, afectos y actitudes en función del sentido de pertenencia de los miembros de la comunidad educativa, logrando apartarse a normas, reglas y valores específicos que se establecen según acuerdos democráticos. Este valor nos permite realizar voluntariamente esfuerzos considerables en beneficio del objeto de compromiso.

                        </p>

                    </article>

                </div>

            </div>

        </section>

    );

};

export default Valores;